export default "__VITE_ASSET__DjCNuFPo__"